import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, keyframes } from '@mui/material';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard after 3 seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        animation: `${fadeIn} 1s ease-out`
      }}
    >
      <Typography
        variant="h2"
        component="h1"
        sx={{
          fontWeight: 800,
          mb: 4,
          background: 'linear-gradient(45deg, #4A90E2 30%, #9013FE 90%)',
          backgroundSize: '200% auto',
          backgroundClip: 'text',
          textFillColor: 'transparent',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: `${gradientAnimation} 3s linear infinite`,
          letterSpacing: '-0.02em',
          fontSize: { xs: '1rem', md: '2rem' }
        }}
      >
        Task Manager
      </Typography>

      <CircularProgress
        size={40}
        thickness={4}
        sx={{
          color: '#9013FE',
          animationDuration: '800ms',
        }}
      />
    </Box>
  );
};

export default SplashScreen;
